export enum RestockType {
  Warehouse = 'WAREHOUSE',
  Supplier = 'SUPPLIER',
  RestockAMZ = 'restockAMZ',
  AWD = 'AWD'
}
